import { createSelector } from '@reduxjs/toolkit';

import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

/**
 * @todo: Код появился в задаче CD-250097, удалить в задаче CD-250490.
 */
export const selectIsBlackFridayEtazhi = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('is_black_friday_etazhi')(jsonQuery),
);
